/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { MarketFeatures } from 'src/config';

const featureFlags: MarketFeatures = {
  // landing page component configuration
  landing: {
    // [Call To Action] section display
    callToAction: true,

    // [How Quartet Works] section display
    howQuartetWorks: true,

    // [Mental Health is Health] section display
    mentalHealth: true
  },

  //Self-Referral form configuration
  selfReferral: {
    // [Select your insurance] form child display
    insurance: false,

    // [Tell us about yourself] form child display
    yourself: true,

    // [What's the best time to call you?] form child display
    call: true,

    // - [Don't have insurance?] form child display
    // - [Don't have insurance?] confirmation form child display
    // - Also controls the display of the copy and link that points to the
    // non-member form on the [Select your insurance] screen
    nonMember: false,

    // Default state (address) selection in the [Almost Done] screen
    defaultState: ''
  }
};

export default featureFlags;
